import WallpaperCalculator from "./wallpaper-calculator";

const $wallpaperCalculator = $(".js-wallpaper-calculator");

if ($wallpaperCalculator.length) {
  const wallpaperCalculator = new WallpaperCalculator();
  const $calculateButton = $wallpaperCalculator.find(
    "[data-wallpaper-calculator-trigger] .btn"
  );
  const $measurementButton = $wallpaperCalculator.find(
    "[data-wallpaper-calculator-measurements] a"
  );
  const $addWallButton = $wallpaperCalculator.find(
    "[data-wallpaper-calculator-width-add] a"
  );

  // change measurement
  $measurementButton.on("click", function (e) {
    e.preventDefault();
    const $clickedMeasurement = $(this);
    const currentMeasurement = $(this).data("measurement");

    wallpaperCalculator.changeMeasurement(
      $clickedMeasurement,
      currentMeasurement
    );

    wallpaperCalculator.resetCalculator($wallpaperCalculator);
  });

  // calculate results
  $calculateButton.on("click", function (e) {
    e.preventDefault();
    if (parseInt($("#wallpaper-height").val()) > 0) {
      if (!$wallpaperCalculator.hasClass("has-reset")) {
        wallpaperCalculator.resetCalculator($wallpaperCalculator);
        wallpaperCalculator.clearInputValues($wallpaperCalculator);
        return;
      }

      setTimeout(() => {
        $('[js-animate-box="bounce"]').addClass("animate");

        setTimeout(() => {
          $('[js-animate-box="bounce"]').removeClass("animate");
        }, 4100);
      }, 500);

      wallpaperCalculator.calculate($wallpaperCalculator);

      $("#wallpaper-height-error").hide();
    } else {
      $("#wallpaper-height-error").show();
    }
  });

  // add additional width wall
  $addWallButton.on("click", function (e) {
    e.preventDefault();
    wallpaperCalculator.addWall($wallpaperCalculator);
    wallpaperCalculator.resetCalculator($wallpaperCalculator);
  });

  // remove additional width wall
  $(document).on("click", ".js-remove-wall", function (e) {
    e.preventDefault();
    wallpaperCalculator.removeWall($wallpaperCalculator);
    wallpaperCalculator.resetCalculator($wallpaperCalculator);
  });
}
